import React, { Component } from 'react';
import { List, Grid, WhiteSpace, Modal, Toast } from 'antd-mobile';
import F2 from '@antv/f2/lib/index';
import df from 'dateformat';
import { ROOT_PATH } from '../../config';
import axios from 'axios';
import { FARM_ORG, ORG_CODE, TOKEN } from '../../cache';
import qs from 'qs';
import FarrowInfoDetail from './farrowInfoDetail';
import EmptyReport from '../../components/EmptyReport';
import DatePicker from '../../components/DatePicker';
import { dateToWeek } from '../../utils/weekToDate';

const today = new Date();
let clientWidth = document.documentElement.clientWidth;
let Shape = F2.Shape;
let Util = F2.Util;
let already = 0;

class FarrowInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      date: today,
      startDate: today,
      endDate: today,
      dateExtra: '',
      startWeek: dateToWeek(today),
      endWeek: dateToWeek(today),
      hasFarrowData: true,
      hasLossData: true,
      hasWeightData: true,
      data: []
    };
  }

  // 获取母猪分娩数量
  getFarrowData = (startDate, endDate) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/number-birthday`,
        qs.stringify({
          startDate: startDate,
          endDate: endDate,
          gd_type: 'D000701',
          gd_code: '1001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.parseFarrowData(res.data);
      })
      .catch((err) => {
        return err;
      });
  };

  // 获取母猪分娩表格数据
  getFarrowTableData = (startDate, endDate) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/farrowDetail`,
        qs.stringify({
          startDate: startDate,
          endDate: endDate,
          gd_type: 'D000701',
          gd_code: '2001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.updateFarrowInfoTable(res.data);
      })
      .catch((err) => {
        return err;
      });
  };

  updateFarrowInfoTable(data) {
    let dataSource = [];
    data.map((obj) => {
      let newObj = {};
      newObj['text'] = obj.descLoc;
      newObj['subText'] = obj.val;
      dataSource.push(newObj);
    });
    this.setState({
      data: dataSource
    });
  }

  // 获取出生即死原因
  getFarrowLossData = (startDate, endDate) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/farrowLossGraph`,
        qs.stringify({
          startDate: startDate,
          endDate: endDate,
          gd_type: 'D000701',
          gd_code: '1009'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.parseFarrowLossData(res.data);
      })
      .catch((execption) => {
        return execption;
      });
  };

  // 获取出生均重分布
  getFarrowWeightData = (startDate, endDate) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/average-birth-weight`,
        qs.stringify({
          startDate: startDate,
          endDate: endDate,
          gd_type: 'D000701',
          gd_code: '3001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        already++;
        this.parseFarrowWeightData(res.data);
      })
      .catch((execption) => {
        return execption;
      });
  };

  // 绘制报表-- '母猪分娩数量
  parseFarrowData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasFarrowData: false });
      return;
    }
    this.setState({ hasFarrowData: true });

    this.drawFarrowReport(data);
  }

  drawFarrowReport = (data) => {
    let chart = this.farrowChart;
    if (chart) {
      chart.clear();
    } else {
      Shape.registerShape('interval', 'farrow-text', {
        draw: function draw(cfg, container) {
          var points = this.parsePoints(cfg.points);

          var style = Util.mix(
            {
              fill: cfg.color,
              z: true
            },
            cfg.style
          );

          var intervalShape = container.addShape('rect', {
            attrs: Util.mix(
              {
                x: points[1].x,
                y: points[1].y,
                width: points[2].x - points[1].x,
                height: points[0].y - points[1].y
              },
              style
            )
          });

          var origin = cfg.origin._origin; // 获取对应的原始数据记录
          var textShape = container.addShape('text', {
            zIndex: 1,
            attrs: {
              x: (points[1].x + points[2].x) / 2,
              y: points[1].y - 5, // 往上偏移 5 像素
              text: origin['qty'],
              fill: '#808080',
              textAlign: 'center',
              textBaseline: 'bottom',
              fontSize: 10 // 字体大小
            }
          });
          container.sort();
          return [intervalShape, textShape];
        }
      });

      chart = new F2.Chart({
        id: 'mountNode1',
        pixelRatio: window.devicePixelRatio,
        padding: [50, 40, 'auto', 40],
        plugins: [
          require('@antv/f2/lib/plugin/scroll-bar'),
          require('@antv/f2/lib/interaction/pan'),
          require('@antv/f2/lib/plugin/gesture')
        ]
      });
    }

    this.farrowChart = chart;

    let originalDate = [];
    let count = [];
    data.map((obj) => {
      let val = obj.transactionDate;
      val = val.replace(new RegExp('-', 'g'), '.').replace('.', '\n');
      obj.transactionDate = val;
      if (originalDate.length < 7) {
        originalDate.push(obj.transactionDate);
      }
      count.push(obj.qty);
    });

    let max = Math.max.apply(null, count);

    let qtyObj = { alias: '分娩数' };
    if (!max) {
      qtyObj['ticks'] = [0, 1, 2, 3, 4, 5];
    } else {
      qtyObj['max'] = max;
      qtyObj['min'] = 0;
      qtyObj['tickCount'] = 6;
    }

    const defs = {
      transactionDate: {
        values: originalDate
      },
      qty: qtyObj
    };

    chart.source(data, defs);

    // 设置坐标轴
    chart.axis('qty', {
      // 分娩数
      position: 'left',
      grid: F2.Global._defaultAxis.grid
    });

    chart.axis('transactionDate', {
      line: {
        lineWidth: 0.5,
        stroke: '#BFBFBF'
      },
      label: {
        fontSize: 10,
        fill: '#666'
      }
    });

    // 设置辅助文本
    chart.guide().text({
      position: ['0%', '0%'],
      content: '分娩数（头）',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fill: '#666'
      },
      offsetY: -20
    });

    // tooltip
    chart.tooltip(false);

    // 定义进度条
    chart.scrollBar({
      mode: 'x',
      xStyle: {
        offsetY: -5
      }
    });

    chart
      .interval()
      .position('transactionDate*qty')
      .color('#1890FF')
      .size(20)
      .shape('farrow-text');

    chart.render();
    chart.interaction('pan', {
      speed: 1
    });

    chart.pluginGesture({
      gesture: {
        tap: (data, ev) => {
          const point = Util.getRelativePosition(ev.center, chart.get('canvas'));
          let plot = chart.get('plotRange');
          const { x, y } = point;
          const { tl, tr, br } = plot;
          if (x >= tl.x && x <= tr.x && y >= tl.y && y <= br.y) {
            const record = chart.getRecord(point);
            let item = {};
            let date = record.transactionDate;
            date = date.replace('\n', '-').replace('.', '-');
            item['startDate'] = date;
            item['endDate'] = date;

            this.setState({
              modalShow: true,
              modalContent: <FarrowInfoDetail data={item} />
            });
          }
        }
      }
    });
  };

  // 绘制报表-- 出生即死原因
  parseFarrowLossData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasLossData: false });
      return;
    }
    this.setState({ hasLossData: true });

    this.drawFarrowLossReport(data);
  }

  drawFarrowLossReport = (data) => {
    let chart = this.deadChart;
    if (chart) {
      chart.clear();
    } else {
      Shape.registerShape('interval', 'loss-text', {
        draw: function draw(cfg, container) {
          var points = this.parsePoints(cfg.points);

          var style = Util.mix(
            {
              fill: cfg.color,
              z: true
            },
            cfg.style
          );

          var intervalShape = container.addShape('rect', {
            attrs: Util.mix(
              {
                x: points[1].x,
                y: points[1].y,
                width: points[2].x - points[1].x,
                height: points[0].y - points[1].y
              },
              style
            )
          });

          var origin = cfg.origin._origin; // 获取对应的原始数据记录
          var textShape = container.addShape('text', {
            zIndex: 1,
            attrs: {
              x: (points[1].x + points[2].x) / 2,
              y: points[1].y - 5, // 往上偏移 5 像素
              text: origin['rate'],
              fill: '#808080',
              textAlign: 'center',
              textBaseline: 'bottom',
              fontSize: 10 // 字体大小
            }
          });
          container.sort();
          return [intervalShape, textShape];
        }
      });

      chart = new F2.Chart({
        id: 'mountNode2',
        pixelRatio: window.devicePixelRatio,
        padding: [50, 40, 'auto', 40]
      });
    }

    this.deadChart = chart;

    let counts = [];
    data.map((obj) => {
      counts.push(obj.rate);
    });
    let max = Math.max.apply(null, counts);

    let qtyObj = { alias: '头数' };
    if (!max) {
      qtyObj['ticks'] = [0, 1, 2, 3, 4, 5];
    }

    const defs = {
      rate: qtyObj
    };

    chart.source(data, defs);

    // 关闭tooltip
    chart.tooltip(false);

    // 设置辅助文本
    chart.guide().text({
      position: ['0%', '0%'],
      content: '头数（头）',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fontColor: '#666'
      },
      offsetY: -20
    });

    // 设置坐标轴
    chart.axis('rate', {
      // 死亡头数
      position: 'left',
      grid: F2.Global._defaultAxis.grid
    });

    chart.axis('descLoc', {
      line: {
        lineWidth: 0.5,
        stroke: '#BFBFBF'
      },
      label: {
        fontSize: 10,
        fill: '#666'
      }
    });

    chart
      .interval()
      .position('descLoc*rate')
      .color('#1890FF')
      .size(20)
      .shape('loss-text');

    chart.render();
  };

  // 绘制报表-- 出生均重分布
  parseFarrowWeightData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasWeightData: false });
      return;
    }
    this.setState({ hasWeightData: true });

    this.drawFarrowWeightReport(data);
  }

  drawFarrowWeightReport = (data) => {
    let chart = this.weightChart;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'mountNode3',
        pixelRatio: window.devicePixelRatio,
        padding: [70, 40, 'auto', 40]
      });
    }

    this.weightChart = chart;

    let counts = [];
    let percents = [];
    data.map((obj) => {
      counts.push(obj.qty);
      percents.push(obj.rate);
    });

    let countMax = Math.max.apply(null, counts);
    let percentMax = Math.max.apply(null, percents);

    let qtyObj = { alias: '头数' };
    if (!countMax) {
      qtyObj['ticks'] = [0, 1, 2, 3, 4, 5];
    }

    let percentObj = { alias: '百分比' };
    if (!percentMax) {
      percentObj['ticks'] = [0, 10, 20, 30, 40, 50];
    }

    const defs = {
      qty: qtyObj,
      rate: percentObj
    };

    chart.source(data, defs);

    // 设置图例
    var legendItems = [
      {
        name: '百分比',
        fill: '#FE5578',
        marker: function marker(x, y, r, ctx) {
          ctx.lineWidth = 1;
          ctx.strokeStyle = ctx.fillStyle;
          ctx.moveTo(x - 3 - r - 5, y);
          ctx.lineTo(x - 3 + r + 5, y);
          ctx.stroke();
          ctx.arc(x - 3, y, 5, 0, Math.PI * 2, false);
          ctx.fill();
        }
      },
      {
        name: '头数',
        marker: {
          symbol: 'circle',
          radius: 5,
          fill: '#1890FF'
        }
      }
    ];

    chart.legend({
      position: 'top',
      align: 'center',
      itemWidth: null,
      itemGap: 35,
      wordSpace: 8,
      custom: true,
      marker: {
        radius: 5
      },
      items: legendItems,
      titleStyle: {
        fill: '#666',
        fontSize: 14
      },
      onClick: function(ev) {
        var item = ev.clickedItem;
        var name = item.get('name');
        var checked = item.get('checked');
        var children = item.get('children');
        if (checked) {
          var markerFill = children[0].attr('fill');
          var textFill = children[1].attr('fill');
          children[0].set('_originColor', markerFill); // 缓存 marker 原来的颜色
          children[1].set('_originColor', textFill); // 缓存文本原来的颜色
        }
        var geoms = chart.get('geoms');
        for (var i = 0; i < geoms.length; i++) {
          var geom = geoms[i];
          if (geom.getYScale().alias === name)
            if (!checked) {
              geom.show();
              children[0].attr('fill', children[0].get('_originColor'));
              children[1].attr('fill', children[1].get('_originColor'));
            } else {
              geom.hide();
              children[0].attr('fill', '#bfbfbf'); // marker 置灰
              children[1].attr('fill', '#bfbfbf'); // 文本置灰 置灰
            }
          item.set('checked', !checked);
        }
      }
    });

    // 设置tooltip
    chart.tooltip({
      showCrosshairs: false,
      showItemMarker: true,
      crosshairsType: 'rect',
      tooltipMarkerStyle: {
        type: 'rect'
      },
      background: {
        radius: 6,
        padding: [6, 10]
      },
      onShow: function onShow(ev) {
        ev.tooltipMarkerCfg.type = 'rect';
        ev.items.splice(1, 1);
      }
    });

    // 设置坐标轴
    chart.axis('qty', {
      // 产仔头数
      position: 'left',
      grid: F2.Global._defaultAxis.grid
    });
    chart.axis('rate', {
      // 百分比
      position: 'right',
      grid: null
    });

    // 设置辅助文本
    chart.guide().text({
      position: ['0%', '0%'],
      content: '产仔数（头）',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fontColor: '#666'
      },
      offsetY: -20
    });

    chart.guide().text({
      position: ['100%', '0%'],
      content: '百分比（%）',
      style: {
        textAlign: 'center',
        fontSize: 9,
        fill: '#666'
      },
      offsetY: -20
    });

    chart
      .interval()
      .position('wgh*qty')
      .color('#1890FF');
    chart
      .area()
      .position('wgh*rate')
      .color('l(90) 0:#FE5578 0.5:#FF91A8 1:#FBEBEF')
      .shape('smooth')
      .style({
        fillOpacity: 0.8
      });
    chart
      .line()
      .position('wgh*rate')
      .shape('smooth')
      .color('#FE5578');
    chart
      .point()
      .position('wgh*rate')
      .color('#FE5578')
      .style({
        fill: '#fff',
        lineWidth: 1
      });
    chart.render();
  };

  doSearch = (start, end, type) => {
    already = 0;
    Toast.loading('加载中...', 0);
    let startDate = df(start, 'yyyy-mm-dd');
    let endDate = df(end, 'yyyy-mm-dd');
    if (type === 'month') {
      let y1 = start.getFullYear();
      let m1 = start.getMonth();
      let firstDay = new Date(y1, m1, 1);
      startDate = df(firstDay, 'yyyy-mm-dd');

      let y2 = end.getFullYear();
      let m2 = end.getMonth();
      let lastDay = new Date(y2, m2 + 1, 0);
      endDate = df(lastDay, 'yyyy-mm-dd');
    }

    let startWeek = dateToWeek(start);
    let endWeek = dateToWeek(end);

    let title = '';
    if (type === 'month') {
      title = `${df(start, 'yyyy-mm')} 至 ${df(end, 'yyyy-mm')}`;
    } else if (type === 'week') {
      title = `${startWeek} 至 ${endWeek}`;
    }

    this.setState({
      startDate,
      endDate,
      startWeek,
      endWeek,
      dateExtra: title
    });

    this.getFarrowData(startDate, endDate);
    this.getFarrowTableData(startDate, endDate);

    this.getFarrowLossData(startDate, endDate);
    this.getFarrowWeightData(startDate, endDate);
  };

  componentDidMount() {
    window._czc && window._czc.push(['_trackEvent', '进入母猪分娩信息页面']);
    this.doSearch(this.state.startDate, this.state.endDate, 'month');
  }

  componentDidUpdate() {
    if (already === 4) {
      Toast.hide();
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  render() {
    return (
      <React.Fragment>
        <List.Item
          arrow="horizontal"
          className="span-4"
          extra={this.state.dateExtra}
          onClick={() => {
            this.setState({ visible: true });
          }}
        >
          选择日期
        </List.Item>
        <DatePicker
          defaultValues={[this.state.startDate, this.state.endDate]}
          mode={['month', 'week']}
          onCancel={() => {
            this.setState({ visible: false });
          }}
          onConfirm={(start, end, type) => {
            let startDate = type === 'week' ? start.startDate : start;
            let endDate = type === 'week' ? end.endDate : end;
            let startWeek = dateToWeek(startDate);
            let endWeek = dateToWeek(endDate);

            this.setState({
              visible: false,
              startDate,
              endDate,
              startWeek,
              endWeek
            });
            this.doSearch(startDate, endDate, type);
          }}
          visible={this.state.visible}
        />
        <List renderHeader={() => ''}>
          <span className="title">所选期间每天分娩数量</span>
          {this.state.hasFarrowData ? (
            <canvas id="mountNode1" height={310} width={clientWidth} />
          ) : (
            <EmptyReport height={310} width={clientWidth} />
          )}
          <div style={{ margin: '15px' }}>
            <Grid
              data={this.state.data}
              columnNum={3}
              itemStyle={{ height: '75px' }}
              renderItem={(dataItem, index) => {
                let textColor = index !== 0 ? '#333' : '#108EE9';
                return (
                  <div style={{ height: '100%' }}>
                    <span className="grid-title">{dataItem.text}</span>
                    <span className="grid-subTitle" style={{ color: textColor }}>
                      {dataItem.subText}
                    </span>
                  </div>
                );
              }}
              onClick={(item, index) => {
                if (index !== 0) {
                  return;
                }
                item['startDate'] = this.state.startDate;
                item['endDate'] = this.state.endDate;
                this.setState({
                  modalShow: true,
                  modalContent: <FarrowInfoDetail data={item} />
                });
              }}
            />
          </div>
          <div style={{ height: '1px' }} />
        </List>
        <List renderHeader={() => ''}>
          <span className="title">出生即死原因分布</span>
          {this.state.hasLossData ? (
            <canvas id="mountNode2" height={250} width={clientWidth} />
          ) : (
            <EmptyReport height={250} width={clientWidth} />
          )}
        </List>
        <List renderHeader={() => ''}>
          <span className="title">出生均重分布</span>
          {this.state.hasWeightData ? (
            <canvas id="mountNode3" height={350} width={clientWidth} />
          ) : (
            <EmptyReport height={350} width={clientWidth} />
          )}
        </List>
        <WhiteSpace size="xl" />
        {/*弹出层公用模态框、*/}
        <Modal
          animationType="slide-up"
          maskClosable={false}
          closable
          onClose={() => {
            this.setState({
              modalShow: false
            });
          }}
          popup
          visible={this.state.modalShow}
        >
          {this.state.modalContent}
        </Modal>
      </React.Fragment>
    );
  }
}

export default FarrowInfo;
